import { notificationLightRed, primaryBlue, red } from '../../../../../../styles/material-ui-theme-v2'
import React from 'react'
import { t } from 'ttag'
import { formatThousands } from '../../../../../../common/helpers/translations'

interface IYumPillProps {
  text?: string
  users?: number
  danger?: boolean
}

const YumPill = (props: IYumPillProps) => {
  const { danger } = props
  const xRaw = props.users || 0
  const x = formatThousands(xRaw)
  const usersText = xRaw == 1 ? t`1 user` : t`${x} users`
  return (
    <div
      style={{
        display: 'inline-block',
        padding: '6px 12px',
        fontSize: '0.875rem',
        color: danger ? red : primaryBlue,
        borderRadius: '28px',
        background: danger ? notificationLightRed : 'rgba(0, 111, 255, 0.10)',
      }}
    >
      {!props.text ? usersText : props.text}
    </div>
  )
}

export default YumPill
